import { BLINK_FLAGS, envFlags } from '@thoughtspot/env-flags';
import { experimentationConfig } from './experiment-keys.const';
export const getUrlFlagValue = (experimentationKey) => {
    const { urlFlag } = experimentationConfig[experimentationKey];
    return envFlags === null || envFlags === void 0 ? void 0 : envFlags.getValue(BLINK_FLAGS[urlFlag].name);
};
export const getFallBackValue = (experimentationKey) => {
    return experimentationConfig[experimentationKey].fallbackValue;
};
//# sourceMappingURL=experiments.config.js.map